export class TokenValid {

    public token: string = "";
    public status: string = "";
    public identifier: string = "";
    //public prefix: String;
    //public phone: string;
    public identifierType: string = "";
    public name: string = "";
    public surnames: string = "";
    //public surname1: string;
    //public surname2: string;
    //public countryCode: string;
    public email: string = "";
    public userCertificate: string = "";
    public method: string = "";
    public companyId: string = "";
    public companyname: string = "";
    //public certificateTypeDesc: string;
    public certificateType: string = "";
    //public error: string;
    public assuranceLevel: string = "";
    public countryCode: string = "";

    constructor() {}

    public getToken(): string {
      return this.token;
    }

    public setToken(value: string) {
      this.token = value;
    }

    public getCertificateType(): string {
      return this.certificateType;
    }

    public setCertificateType(value: string) {
      this.certificateType = value;
    }

    public getCompanyid(): string {
      return this.companyId;
    }

    public setCompanyid(value: string) {
      this.companyId = value;
    }

    
  }